import React from "react";
import UIButton from "./ui/UIButtons";
import navaratriBanner from "../assets/banners/NavratriBannerResized-2026.png";

export default function Hero() {
  return (
    <section className="bg-[#fff7ed]">
      {/* Full banner: preserves its original proportions on every screen */}
      <img
        src={navaratriBanner}
        alt="Airdrie Gujarati Samaj Navratri 2026 banner"
        className="block h-auto w-full"
      />

      <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 md:py-12 lg:px-8">
        <div className="rounded-3xl bg-white p-5 shadow-lg sm:p-7 lg:p-10">
          <div className="inline-flex rounded-full bg-[#d4503e] px-4 py-2 text-xs font-extrabold uppercase tracking-wide text-white">
            🪔 Navratri 2026 • October 10 & 11
          </div>

          <h1 className="mt-5 text-3xl font-extrabold leading-tight text-gray-900 sm:text-4xl lg:text-5xl">
            Navratri 2026
          </h1>

          <p className="mt-2 text-lg font-bold text-[#b84a24] sm:text-xl">
            Garba • Music • Culture • Community
          </p>

          <p className="mt-4 max-w-3xl text-sm leading-relaxed text-gray-700 sm:text-base">
            Celebrate Navratri with Airdrie Gujarati Samaj! Join us for two
            evenings of Garba, music, dance, culture, and community.
          </p>

          <div className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            <InfoBox label="Dates" value="October 10 & 11, 2026" />
            <InfoBox label="Time" value="6:30 PM onwards" />
            <InfoBox label="Featuring" value="DJ Prince & DJ Vaibhav" />
          </div>

          <div className="mt-3 rounded-2xl bg-orange-50 p-4">
            <p className="text-xs font-bold uppercase tracking-wide text-[#b84a24]">
              📍 Venue
            </p>
            <p className="mt-1 text-sm font-bold text-gray-900 sm:text-base">
              Town & Country Community Hall
              <br />
              275 Jensen Dr NE, Airdrie, AB
            </p>
          </div>

          <div className="mt-6 flex flex-col gap-3 sm:flex-row">
            <UIButton to="/events" variant="saffron">
              View Event
            </UIButton>
            <UIButton to="/membershipdashboard" variant="green">
              Become a Member
            </UIButton>
          </div>
        </div>
      </div>
    </section>
  );
}

function InfoBox({ label, value }) {
  return (
    <div className="rounded-2xl bg-orange-50 p-4">
      <p className="text-xs font-bold uppercase tracking-wide text-[#b84a24]">
        {label}
      </p>
      <p className="mt-1 text-sm font-bold text-gray-900">{value}</p>
    </div>
  );
}